export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_REFRESH = "AUTH_REFRESH";
export const AUTH_REFRESH_SUCCESS = "AUTH_REFRESH_SUCCESS";
export const AUTH_REFRESH_ERROR = "AUTH_REFRESH_ERROR";
